import RandingStyle9 from "../../randing/RandingStyle9";

function Randing229({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle9
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/229/1.png`}
      formFieldColor="white"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/green/benetfitButton.png`}
      adTarget="맘카페 이용자"
      eventDates={true}
      companyName="우가주치과병원"
      footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/uga.png`}
    />
  );
}

export default Randing229;
